import "core-js/modules/es6.promise";
import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import { getMeetingsWithDecisions, getMeetingDecisions, updateDecision, storeDecision, destroyDecision } from "src/models/Decision";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload";
import { commitPagination, hasNextPage } from "src/store/utils/pagination"; // Init state

var initState = function initState() {
  return {
    allMeetingsAndDecisions: [],
    meetingDecisions: [],
    decisionsPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreDecisions: true,
    loading: {
      meetingDecisions: false,
      decisions: false
    }
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setAllMeetingsAndDecisions: function setAllMeetingsAndDecisions(state, payload) {
    state.allMeetingsAndDecisions = payload;
  },
  appendMeetingsAndDecisions: function appendMeetingsAndDecisions(state, payload) {
    var existingIds = new Set(state.allMeetingsAndDecisions.map(function (item) {
      return item.id;
    }));
    var newItems = payload.filter(function (item) {
      return !existingIds.has(item.id);
    });
    state.allMeetingsAndDecisions = [].concat(_toConsumableArray(state.allMeetingsAndDecisions), _toConsumableArray(newItems));
  },
  updateDecisionsPagination: function updateDecisionsPagination(state, pagination) {
    state.decisionsPagination.currentPage = pagination.currentPage;
    state.decisionsPagination.total_pages = pagination.total_pages;
  },
  setHasMoreDecisions: function setHasMoreDecisions(state, value) {
    state.hasMoreDecisions = value;
  },
  setDecisionsLoading: function setDecisionsLoading(state, payload) {
    state.loading.decisions = payload;
  },
  setMeetingDecisions: function setMeetingDecisions(state, payload) {
    state.meetingDecisions = payload;
  },
  setMeetingDecisionsLoading: function setMeetingDecisionsLoading(state, payload) {
    state.loading.meetingDecisions = payload;
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  fetchAllMeetingsAndDecisions: function fetchAllMeetingsAndDecisions(_ref) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, group, _response$data, _response$data2, _response$data2$meta, response, decisions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              commit("setDecisionsLoading", true);
              commit("setHasMoreDecisions", true);
              group = _this.getters["Group/group"];
              _context.prev = 4;
              _context.next = 7;
              return getMeetingsWithDecisions(group.id, 1);

            case 7:
              response = _context.sent;
              decisions = Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
              commit("setAllMeetingsAndDecisions", decisions);
              commitPagination(commit, (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$meta = _response$data2.meta) === null || _response$data2$meta === void 0 ? void 0 : _response$data2$meta.pagination, {
                update: "updateDecisionsPagination",
                setHasMore: "setHasMoreDecisions"
              });
              commit("setDecisionsLoading", false);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              errorDialog.showErrorMessageFromServer(getErrorPayload(_context.t0));
              commit("setDecisionsLoading", false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }))();
  },
  fetchMoreDecisions: function fetchMoreDecisions(_ref2) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, group, nextPage, _response$data3, _response$data4, _response$data4$meta, response, decisions;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, state = _ref2.state;
              group = _this2.getters["Group/group"];

              if (!state.loading.decisions) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              if (hasNextPage(state, "decisionsPagination")) {
                _context2.next = 7;
                break;
              }

              commit("setHasMoreDecisions", false);
              return _context2.abrupt("return");

            case 7:
              commit("setDecisionsLoading", true);
              nextPage = state.decisionsPagination.currentPage + 1;
              _context2.prev = 9;
              _context2.next = 12;
              return getMeetingsWithDecisions(group.id, nextPage);

            case 12:
              response = _context2.sent;
              decisions = Array.isArray((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
              commit("appendMeetingsAndDecisions", decisions);
              commitPagination(commit, (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$meta = _response$data4.meta) === null || _response$data4$meta === void 0 ? void 0 : _response$data4$meta.pagination, {
                update: "updateDecisionsPagination",
                setHasMore: "setHasMoreDecisions"
              });
              commit("setDecisionsLoading", false);
              _context2.next = 23;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](9);
              errorDialog.showErrorMessageFromServer(getErrorPayload(_context2.t0));
              commit("setDecisionsLoading", false);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[9, 19]]);
    }))();
  },
  fetchMeetingDecisions: function fetchMeetingDecisions(_ref3) {
    var commit = _ref3.commit;
    commit("setMeetingDecisionsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve) {
      getMeetingDecisions(group.id, meeting.id).then(function (response) {
        commit("setMeetingDecisions", response.data.data);
        commit("setMeetingDecisionsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMeetingDecisionsLoading", false);
      });
    });
  },
  createMeetingDecision: function createMeetingDecision(_ref4, request) {
    var commit = _ref4.commit;
    commit("setMeetingDecisionsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    request["meeting_id"] = meeting.id;
    return new Promise(function (resolve) {
      storeDecision(group.id, request).then(function () {
        commit("setMeetingDecisionsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMeetingDecisionsLoading", false);
      });
    });
  },
  editDecision: function editDecision(_ref5, request) {
    var commit = _ref5.commit;
    commit("setMeetingDecisionsLoading", true);
    var group = this.getters["Group/group"];
    var decisionId = request["id"];
    return new Promise(function (resolve) {
      updateDecision(group.id, decisionId, request).then(function () {
        commit("setMeetingDecisionsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMeetingDecisionsLoading", false);
      });
    });
  },
  remove: function remove(_ref6, id) {
    var commit = _ref6.commit;
    commit("setMeetingDecisionsLoading", true);
    var group = this.getters["Group/group"];
    return new Promise(function (resolve) {
      destroyDecision(group.id, id).then(function (response) {
        commit("setMeetingDecisionsLoading", false);
        resolve(response);
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMeetingDecisionsLoading", false);
      });
    });
  }
}; // Getter functions

var getters = {
  allMeetingsAndDecisions: function allMeetingsAndDecisions(state) {
    return state.allMeetingsAndDecisions;
  },
  hasMoreDecisions: function hasMoreDecisions(state) {
    return state.hasMoreDecisions;
  },
  decisionsLoading: function decisionsLoading(state) {
    return state.loading.decisions;
  },
  meetingDecisions: function meetingDecisions(state) {
    return state.meetingDecisions;
  },
  meetingDecisionsLoading: function meetingDecisionsLoading(state) {
    return state.loading.meetingDecisions;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};